import React from "react";
import { WATaskSingleSettingsStack } from "../WATaskSingleStack";
import { WATaskSingleSettingsScreen } from "./WATaskSingleSettingsScreen";
import { WATaskSingleSettingsSelectRoutine } from "./WATaskSingleSettingsSelectRoutine";
import { useTheme } from "arkh";
import { WATaskSingleSettingsTasks } from "./WATaskSingleSettingsSelectTask";
import { useIntlTokens } from "../../../../../../../components/mobile/useIntlTokens";
import { useNavigationHeaderOptions } from "../../../../../../../common/navigationHeaderOptions";

export function WATaskSingleSettings() {
  const theme = useTheme();
  const intl_tokens = useIntlTokens();
  const getHeaderOptions = useNavigationHeaderOptions();
  return (
    <WATaskSingleSettingsStack.Navigator
      screenOptions={{
        contentStyle: {
          backgroundColor: theme["surface-background-light"],
        },
      }}
    >
      <WATaskSingleSettingsStack.Screen
        name="WATaskSingleSettingsSelectRoutine"
        component={WATaskSingleSettingsSelectRoutine}
        options={({ navigation }) =>
          getHeaderOptions({
            type: "CANCEL",
            onClose: () => navigation.goBack(),
            title: intl_tokens.SelectTask,
            defaultContentStyle: true,
          })
        }
      />
      <WATaskSingleSettingsStack.Screen
        name="WATaskSingleSettingsSelectTask"
        component={WATaskSingleSettingsTasks}
        options={({ navigation }) =>
          getHeaderOptions({
            type: "BACK",
            onBack: () => {
              navigation.goBack();
            },
            title: intl_tokens.SelectTask,
            defaultContentStyle: true,
          })
        }
      />
      <WATaskSingleSettingsStack.Screen
        name="WATaskSingleSettings"
        component={WATaskSingleSettingsScreen}
        options={({ navigation }) =>
          getHeaderOptions({
            type: "BACK",
            onBack: () => {
              navigation.goBack();
            },
            title: intl_tokens.Task,
            defaultContentStyle: true,
          })
        }
      />
    </WATaskSingleSettingsStack.Navigator>
  );
}
